/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BoothDto } from '../models/booth-dto';
import { floorPlanControllerAssignCompanyV1 } from '../fn/floor-plan/floor-plan-controller-assign-company-v-1';
import { FloorPlanControllerAssignCompanyV1$Params } from '../fn/floor-plan/floor-plan-controller-assign-company-v-1';
import { floorPlanControllerCreateBoothV1 } from '../fn/floor-plan/floor-plan-controller-create-booth-v-1';
import { FloorPlanControllerCreateBoothV1$Params } from '../fn/floor-plan/floor-plan-controller-create-booth-v-1';
import { floorPlanControllerCreateV1 } from '../fn/floor-plan/floor-plan-controller-create-v-1';
import { FloorPlanControllerCreateV1$Params } from '../fn/floor-plan/floor-plan-controller-create-v-1';
import { floorPlanControllerDeleteBoothV1 } from '../fn/floor-plan/floor-plan-controller-delete-booth-v-1';
import { FloorPlanControllerDeleteBoothV1$Params } from '../fn/floor-plan/floor-plan-controller-delete-booth-v-1';
import { floorPlanControllerDeleteV1 } from '../fn/floor-plan/floor-plan-controller-delete-v-1';
import { FloorPlanControllerDeleteV1$Params } from '../fn/floor-plan/floor-plan-controller-delete-v-1';
import { floorPlanControllerFindBoothsByFloorPlanIdV1 } from '../fn/floor-plan/floor-plan-controller-find-booths-by-floor-plan-id-v-1';
import { FloorPlanControllerFindBoothsByFloorPlanIdV1$Params } from '../fn/floor-plan/floor-plan-controller-find-booths-by-floor-plan-id-v-1';
import { floorPlanControllerFindByEventIdV1 } from '../fn/floor-plan/floor-plan-controller-find-by-event-id-v-1';
import { FloorPlanControllerFindByEventIdV1$Params } from '../fn/floor-plan/floor-plan-controller-find-by-event-id-v-1';
import { floorPlanControllerFindByIdV1 } from '../fn/floor-plan/floor-plan-controller-find-by-id-v-1';
import { FloorPlanControllerFindByIdV1$Params } from '../fn/floor-plan/floor-plan-controller-find-by-id-v-1';
import { floorPlanControllerUpdateBoothV1 } from '../fn/floor-plan/floor-plan-controller-update-booth-v-1';
import { FloorPlanControllerUpdateBoothV1$Params } from '../fn/floor-plan/floor-plan-controller-update-booth-v-1';
import { floorPlanControllerUpdateV1 } from '../fn/floor-plan/floor-plan-controller-update-v-1';
import { FloorPlanControllerUpdateV1$Params } from '../fn/floor-plan/floor-plan-controller-update-v-1';
import { FloorPlanDto } from '../models/floor-plan-dto';

@Injectable({ providedIn: 'root' })
export class FloorPlanService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `floorPlanControllerFindByEventIdV1()` */
  static readonly FloorPlanControllerFindByEventIdV1Path = '/api/v1/floor-plan/event/{eventId}';

  /**
   * 행사별 배치도 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerFindByEventIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindByEventIdV1$Response(params: FloorPlanControllerFindByEventIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FloorPlanDto>>> {
    return floorPlanControllerFindByEventIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 행사별 배치도 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerFindByEventIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindByEventIdV1(params: FloorPlanControllerFindByEventIdV1$Params, context?: HttpContext): Observable<Array<FloorPlanDto>> {
    return this.floorPlanControllerFindByEventIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FloorPlanDto>>): Array<FloorPlanDto> => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerFindByIdV1()` */
  static readonly FloorPlanControllerFindByIdV1Path = '/api/v1/floor-plan/{id}';

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindByIdV1$Response(params: FloorPlanControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    return floorPlanControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindByIdV1(params: FloorPlanControllerFindByIdV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    return this.floorPlanControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerDeleteV1()` */
  static readonly FloorPlanControllerDeleteV1Path = '/api/v1/floor-plan/{id}';

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerDeleteV1$Response(params: FloorPlanControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return floorPlanControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerDeleteV1(params: FloorPlanControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.floorPlanControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerUpdateV1()` */
  static readonly FloorPlanControllerUpdateV1Path = '/api/v1/floor-plan/{id}';

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerUpdateV1$Response(params: FloorPlanControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    return floorPlanControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerUpdateV1(params: FloorPlanControllerUpdateV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    return this.floorPlanControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerCreateV1()` */
  static readonly FloorPlanControllerCreateV1Path = '/api/v1/floor-plan';

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerCreateV1$Response(params: FloorPlanControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    return floorPlanControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerCreateV1(params: FloorPlanControllerCreateV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    return this.floorPlanControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerFindBoothsByFloorPlanIdV1()` */
  static readonly FloorPlanControllerFindBoothsByFloorPlanIdV1Path = '/api/v1/floor-plan/{floorPlanId}/booths';

  /**
   * 배치도별 부스 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerFindBoothsByFloorPlanIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindBoothsByFloorPlanIdV1$Response(params: FloorPlanControllerFindBoothsByFloorPlanIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothDto>>> {
    return floorPlanControllerFindBoothsByFloorPlanIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도별 부스 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerFindBoothsByFloorPlanIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerFindBoothsByFloorPlanIdV1(params: FloorPlanControllerFindBoothsByFloorPlanIdV1$Params, context?: HttpContext): Observable<Array<BoothDto>> {
    return this.floorPlanControllerFindBoothsByFloorPlanIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BoothDto>>): Array<BoothDto> => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerCreateBoothV1()` */
  static readonly FloorPlanControllerCreateBoothV1Path = '/api/v1/floor-plan/booth';

  /**
   * 부스 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerCreateBoothV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerCreateBoothV1$Response(params: FloorPlanControllerCreateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
    return floorPlanControllerCreateBoothV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerCreateBoothV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerCreateBoothV1(params: FloorPlanControllerCreateBoothV1$Params, context?: HttpContext): Observable<BoothDto> {
    return this.floorPlanControllerCreateBoothV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothDto>): BoothDto => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerDeleteBoothV1()` */
  static readonly FloorPlanControllerDeleteBoothV1Path = '/api/v1/floor-plan/booth/{id}';

  /**
   * 부스 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerDeleteBoothV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerDeleteBoothV1$Response(params: FloorPlanControllerDeleteBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return floorPlanControllerDeleteBoothV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerDeleteBoothV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanControllerDeleteBoothV1(params: FloorPlanControllerDeleteBoothV1$Params, context?: HttpContext): Observable<boolean> {
    return this.floorPlanControllerDeleteBoothV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerUpdateBoothV1()` */
  static readonly FloorPlanControllerUpdateBoothV1Path = '/api/v1/floor-plan/booth/{id}';

  /**
   * 부스 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerUpdateBoothV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerUpdateBoothV1$Response(params: FloorPlanControllerUpdateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
    return floorPlanControllerUpdateBoothV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerUpdateBoothV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerUpdateBoothV1(params: FloorPlanControllerUpdateBoothV1$Params, context?: HttpContext): Observable<BoothDto> {
    return this.floorPlanControllerUpdateBoothV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothDto>): BoothDto => r.body)
    );
  }

  /** Path part for operation `floorPlanControllerAssignCompanyV1()` */
  static readonly FloorPlanControllerAssignCompanyV1Path = '/api/v1/floor-plan/booth/{id}/assign';

  /**
   * 부스에 업체 할당/해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanControllerAssignCompanyV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerAssignCompanyV1$Response(params: FloorPlanControllerAssignCompanyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
    return floorPlanControllerAssignCompanyV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스에 업체 할당/해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanControllerAssignCompanyV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanControllerAssignCompanyV1(params: FloorPlanControllerAssignCompanyV1$Params, context?: HttpContext): Observable<BoothDto> {
    return this.floorPlanControllerAssignCompanyV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothDto>): BoothDto => r.body)
    );
  }

}
